import PropTypes from "prop-types";
import React from "react";
import Popup from "reactjs-popup";
import { Lock01 } from "@opendate-app/setlist";

const moreMenuContentStyle = {
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: "8px",
  boxShadow: "0 4px 6px -2px rgba(10,13,18,0.03), 0 12px 16px -4px rgba(10,13,18,0.08)",
  width: "220px",
  padding: "4px",
  background: "var(--sl-bg-primary)",
  // Above the sticky tab strip (z-index: 100 in eventPageStyles.css).
  zIndex: 9999,
};

const TabButton = ({ tab, isActive, onSelect }) => (
  <button
    type="button"
    role="tab"
    data-tab={tab.key}
    aria-selected={isActive ? "true" : "false"}
    onClick={() => onSelect(tab.key)}
    className={`tab ${isActive ? "active" : ""}`.trim()}
  >
    {tab.locked && <Lock01 width={14} height={14} aria-hidden="true" />}
    {tab.label}
    {tab.badge && <span className="tab-badge-green">{tab.badge}</span>}
    {tab.count != null && <span className="tab-badge">{tab.count}</span>}
    {tab.alert && <span className="tab-badge-alert" aria-label={`${tab.alert} need attention`}>!</span>}
    {tab.dot && <span className="tab-dot-alert" aria-hidden="true" />}
  </button>
);

TabButton.propTypes = {
  tab: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

const EventTabNav = ({ tabs, active, onSelect }) => {
  const activeTab = tabs.find((t) => t.key === active) || tabs[0];
  const otherTabs = tabs.filter((t) => t.key !== activeTab.key);

  return (
    <>
      {/* Desktop: the full horizontally-scrolling tab strip. */}
      <div className="tabs-container tabs-container--desktop">
        <div className="tabs" role="tablist">
          {tabs.map((tab) => (
            <TabButton key={tab.key} tab={tab} isActive={active === tab.key} onSelect={onSelect} />
          ))}
        </div>
      </div>

      {/* Phone: only the active tab, with the rest folded into a "More" dropdown. */}
      <div className="tabs-container tabs-container--mobile">
        <div className="tabs" role="tablist">
          <TabButton tab={activeTab} isActive onSelect={onSelect} />
          <Popup
            arrow={false}
            offsetY={6}
            position="bottom left"
            contentStyle={moreMenuContentStyle}
            onOpen={(e) => { e.stopPropagation(); e.preventDefault(); }}
            trigger={
              <button type="button" className="tab tab-more">
                More
                <span className="tab-badge">{otherTabs.length}</span>
                <i className="fas fa-chevron-down" style={{ fontSize: "12px" }} />
              </button>
            }
          >
            {(close) => (
              <div className="event-actions-menu" role="tablist">
                {otherTabs.map((tab) => (
                  <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    className="event-actions-item"
                    onClick={() => { onSelect(tab.key); close(); }}
                  >
                    {tab.label}
                    {tab.alert && <span className="tab-badge-alert" aria-hidden="true">!</span>}
                    {tab.badge && (
                      <span style={{ marginLeft: "auto", fontSize: "11px", fontWeight: 600, color: "var(--sl-text-success)" }}>
                        {tab.badge}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            )}
          </Popup>
        </div>
      </div>
    </>
  );
};

EventTabNav.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number,
    badge: PropTypes.string,
    alert: PropTypes.string,
    dot: PropTypes.bool,
    locked: PropTypes.bool,
  })).isRequired,
  active: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default EventTabNav;
